import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let DeleteContactUsThunk = createAsyncThunk(
	"ContactUs/DeleteContactUsThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.delete(`/api/admin/contact_us/${arg?.id}`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
